module.exports = __webpack_public_path__ + "img/no_orders.f93e2442.svg";